
(function(){
  "use strict";
  /* header scroll state */
  var header=document.getElementById('milan-header');
  function onScroll(){ if(!header)return; header.classList.toggle('scrolled', window.scrollY>40); }
  window.addEventListener('scroll',onScroll,{passive:true}); onScroll();

  /* mobile menu */
  var menu=document.getElementById('mobile-menu');
  document.querySelectorAll('[data-open-menu]').forEach(function(b){ b.addEventListener('click',function(){ menu.classList.remove('hidden-menu'); document.body.style.overflow='hidden'; }); });
  document.querySelectorAll('[data-close-menu]').forEach(function(b){ b.addEventListener('click',function(){ menu.classList.add('hidden-menu'); document.body.style.overflow=''; }); });
  if(menu){ menu.querySelectorAll('a').forEach(function(a){ a.addEventListener('click',function(){ menu.classList.add('hidden-menu'); document.body.style.overflow=''; }); }); }

  /* booking modal */
  var modal=document.getElementById('booking-modal');
  document.querySelectorAll('[data-open-booking]').forEach(function(b){ b.addEventListener('click',function(){ if(menu)menu.classList.add('hidden-menu'); modal.classList.remove('hidden-menu'); document.body.style.overflow='hidden'; }); });
  document.querySelectorAll('[data-close-booking]').forEach(function(b){ b.addEventListener('click',function(){ modal.classList.add('hidden-menu'); document.body.style.overflow=''; }); });
  if(modal){ modal.addEventListener('click',function(e){ if(e.target===modal){modal.classList.add('hidden-menu');document.body.style.overflow='';} }); }
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'){ if(modal)modal.classList.add('hidden-menu'); if(menu)menu.classList.add('hidden-menu'); document.body.style.overflow=''; } });
  if(/contact_posted=true/.test(location.search) && modal){ modal.classList.remove('hidden-menu'); }

  /* before / after slider */
  document.querySelectorAll('[data-compare]').forEach(function(box){
    var before=box.querySelector('[data-compare-before]'),
        handles=box.querySelectorAll('[data-compare-handle]'),
        knob=box.querySelector('[role="slider"]');
    var labelBefore=box.querySelector('[data-compare-label-before]'), labelAfter=box.querySelector('[data-compare-label-after]');
    function setPos(clientX){
      var r=box.getBoundingClientRect(), p=((clientX-r.left)/r.width)*100;
      p=Math.max(4,Math.min(96,p));
      before.style.clipPath='inset(0 '+(100-p)+'% 0 0)';
      handles.forEach(function(h){h.style.left=p+'%';});
      if(knob)knob.setAttribute('aria-valuenow',Math.round(p));
      if(labelBefore)labelBefore.style.opacity=p<18?0:1;
      if(labelAfter)labelAfter.style.opacity=p>82?0:1;
    }
    var dragging=false;
    box.addEventListener('pointerdown',function(e){dragging=true;try{box.setPointerCapture(e.pointerId);}catch(_){}setPos(e.clientX);});
    box.addEventListener('pointermove',function(e){if(dragging)setPos(e.clientX);});
    ['pointerup','pointercancel'].forEach(function(ev){box.addEventListener(ev,function(){dragging=false;});});
    if(knob){knob.addEventListener('keydown',function(e){
      var v=parseFloat(knob.getAttribute('aria-valuenow'))||50;
      if(e.key==='ArrowLeft'||e.key==='ArrowRight'){
        e.preventDefault();
        v=Math.max(4,Math.min(96,v+(e.key==='ArrowRight'?4:-4)));
        var r=box.getBoundingClientRect(); setPos(r.left+(v/100)*r.width);
      }
    });}
  });

  /* faq accordion */
  document.querySelectorAll('.faq-item > button').forEach(function(btn){
    btn.addEventListener('click',function(){
      var item=btn.closest('.faq-item'), open=item.classList.contains('open');
      item.parentElement.querySelectorAll('.faq-item.open').forEach(function(o){o.classList.remove('open');o.querySelector('button').setAttribute('aria-expanded','false');});
      if(!open){item.classList.add('open');btn.setAttribute('aria-expanded','true');}
    });
  });

  /* reveal on scroll */
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-visible');io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -40px 0px'});
  document.querySelectorAll('.reveal').forEach(function(el){io.observe(el);});
})();
